import { actions, STATES } from "src/requestProgress/reducer";
import store from "../store";
import { resetRequestProgress } from "./actions";
import { IsFinishedState } from "./types";

export const transitionIfFinished = (actionName: actions): IsFinishedState => {
  const requestState = store.getState().requestProgress[actionName];
  const isFinishedState = {
    finished: requestState === STATES.LOADED || requestState === STATES.ERROR,
    success: requestState !== STATES.ERROR,
    loaded: requestState === STATES.LOADED
  };

  if (isFinishedState.finished) {
    store.dispatch(resetRequestProgress(actionName));
  }
  return isFinishedState;
};

export const isRequesting = (actionName: actions): boolean => {
  const requestState = store.getState().requestProgress[actionName];
  const isRequestInProgress = Boolean(
    requestState && requestState === STATES.LOADING
  );
  return isRequestInProgress;
};



// WEBPACK FOOTER //
// ./src/requestProgress/helpers.ts